/**
 * Company Email Manager
 * Handles dynamic email field management for company forms
 */

class CompanyEmailManager {
  constructor() {
    this.initializeEventListeners();
  }

  initializeEventListeners() {
    // Add event listeners for all add email buttons
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('add-email-btn')) {
        const emailType = event.target.dataset.emailType;
        this.addEmailRow(emailType);
      }
    });

    // Add event listeners for all remove email buttons
    document.addEventListener('click', (event) => {
      if (event.target.classList.contains('remove-email-btn')) {
        this.removeEmailRow(event.target);
      }
    });
  }

  addEmailRow(emailType) {
    const container = document.getElementById(`${emailType}-emails`);
    if (!container) return;

    const newRow = document.createElement('div');
    newRow.className = 'email-row';
    newRow.style.cssText = 'display: flex; gap: 5px; margin-bottom: 5px;';
    
    const input = document.createElement('input');
    input.type = 'text';
    input.name = `company[${emailType}_emails][]`;
    input.className = 'email-input';
    input.style.cssText = 'flex: 1; border: 1px solid #ddd; padding: 6px 8px; font-size: 13px;';
    input.placeholder = this.getPlaceholderForType(emailType);
    
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'remove-email-btn';
    button.style.cssText = 'background: #dc3545; color: white; border: none; padding: 6px 10px; cursor: pointer; border-radius: 3px;';
    button.innerHTML = '❌';
    button.title = 'Eliminar email';
    
    newRow.appendChild(input);
    newRow.appendChild(button);
    container.appendChild(newRow);
    
    // Focus on the new input
    input.focus();
  }

  removeEmailRow(button) {
    const container = button.closest('.email-container');
    const rows = container.querySelectorAll('.email-row');
    
    // Don't remove if it's the last row
    if (rows.length > 1) {
      button.closest('.email-row').remove();
    }
  }

  getPlaceholderForType(emailType) {
    const placeholders = {
      'collection': 'cobranzasg2@unnio.cl',
      'claims': 'siniestros@zurich.cl',
      'endorsement': 'mesadeentrada@chubb.cl'
    };
    return placeholders[emailType] || 'email@ejemplo.com';
  }

  // Method to validate email format
  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  // Method to validate all emails in a container
  validateAllEmails(emailType) {
    const container = document.getElementById(`${emailType}-emails`);
    const inputs = container.querySelectorAll('.email-input');
    let isValid = true;

    inputs.forEach(input => {
      const email = input.value.trim();
      if (email && !this.validateEmail(email)) {
        input.style.borderColor = '#dc3545';
        isValid = false;
      } else {
        input.style.borderColor = '#ddd';
      }
    });

    return isValid;
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CompanyEmailManager();
});
